/* EVAMATS — „Moje konto” v2. (1) Przełącznik stanów podglądu: tylko gdy na stronie jest znacznik podglądu (poza motywem main go nie ma).
   (2) Sprawdzanie salda karty podarunkowej przez publiczny Storefront API sklepu (bez tokenu, bez zapisywania kodu).
   Kod nigdy nie trafia do adresu strony, do localStorage ani do logów. */
(function () {
  var root = document.querySelector('[data-evm-v2]');
  if (!root) return;

  // ---------- stany podglądu ----------
  var STATES = ['signed-out', 'signed-in', 'signed-in-new'];
  var isCustomer = root.getAttribute('data-customer') === 'true';
  var chips = root.querySelectorAll('[data-evm-state]');
  var hasDemo = chips.length > 0;
  var fromUrl = new URLSearchParams(window.location.search).get('evm_account_demo');
  var state = hasDemo && STATES.indexOf(fromUrl) > -1 ? fromUrl : (isCustomer ? 'real-in' : 'real-out');

  function render(next, updateUrl) {
    state = next;
    root.setAttribute('data-state', state);
    root.querySelectorAll('[data-only]').forEach(function (el) {
      el.hidden = el.getAttribute('data-only').split(' ').indexOf(state) === -1;
    });
    chips.forEach(function (chip) {
      chip.setAttribute('aria-pressed', String(chip.getAttribute('data-evm-state') === state));
    });
    if (updateUrl) {
      var url = new URL(window.location.href);
      url.searchParams.set('evm_account_demo', state);
      window.history.replaceState(null, '', url.toString());
    }
  }
  chips.forEach(function (chip) {
    chip.addEventListener('click', function () { render(chip.getAttribute('data-evm-state'), true); });
  });
  render(state, false);

  // ---------- saldo karty podarunkowej ----------
  // UWAGA: ta sama wersja Storefront API jest też w evm-coins-use.js; przy zmianie wersji (2026-04 wygasa ok. kwietnia 2027) zmień oba pliki.
  var API = '/api/2026-04/graphql.json';
  var Q_CREATE = 'mutation($lines:[CartLineInput!]){cartCreate(input:{lines:$lines}){cart{id} userErrors{message}}}';
  var Q_ADD = 'mutation($id:ID!,$codes:[String!]!){cartGiftCardCodesAdd(cartId:$id,giftCardCodes:$codes){cart{appliedGiftCards{lastCharacters balance{amount currencyCode} amountUsed{amount}}} userErrors{message code} warnings{message code}}}';

  var Q_ADD_REAL = 'mutation($id:ID!,$codes:[String!]!){cartGiftCardCodesAdd(cartId:$id,giftCardCodes:$codes){cart{appliedGiftCards{lastCharacters balance{amount currencyCode} amountUsed{amount}}} userErrors{message code}}}';

  function call(query, variables) {
    return fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function (r) {
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    });
  }

  // Tworzy tymczasowy koszyk (nie ten klienta), dodaje do niego kod i oddaje listę zastosowanych kart.
  function tryCode(code, lines) {
    return call(Q_CREATE, { lines: lines }).then(function (c) {
      var cart = c && c.data && c.data.cartCreate && c.data.cartCreate.cart;
      if (!cart || !cart.id) throw new Error('no cart');
      return call(Q_ADD, { id: cart.id, codes: [code] });
    }).then(function (r) {
      var add = r && r.data && r.data.cartGiftCardCodesAdd;
      return (add && add.cart && add.cart.appliedGiftCards) || [];
    });
  }

  function money(amount, currency) {
    var n = Number(amount);
    if (!isFinite(n)) return '';
    var s = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return s + ' ' + (!currency || currency === 'PLN' ? 'zł' : currency);
  }

  root.querySelectorAll('[data-evm-gc-form]').forEach(function (form) {
    var input = form.querySelector('input[name="code"]');
    var button = form.querySelector('button[type="submit"]');
    var status = form.querySelector('[data-evm-gc-status]');
    
    // Komunikaty budujemy z węzłów DOM: tekst, opcjonalne wyróżnienie i link do koszyka.
    function say(kind, text, strong, tail, withCartLink) {
      status.hidden = false;
      status.setAttribute('data-kind', kind);
      status.textContent = '';
      status.appendChild(document.createTextNode(text));
      if (strong) {
        var b = document.createElement('strong');
        b.textContent = strong;
        status.appendChild(b);
      }
      if (tail) status.appendChild(document.createTextNode(tail));
      if (withCartLink) {
        status.appendChild(document.createTextNode(' '));
        var a = document.createElement('a');
        a.href = withCartLink === 'checkout' ? '/checkout' : '/cart';
        a.textContent = withCartLink === 'checkout' ? 'Przejdź do kasy' : 'Przejdź do koszyka';
        status.appendChild(a);
      }
    }
    // Wizualizacja karty nad polem: pokazuje ostatnie 4 znaki i saldo po udanym sprawdzeniu.
    var tile = form.closest('.evm-v2-gc');
    var vLast = tile && tile.querySelector('[data-evm-gc-card-last]');
    var vBal = tile && tile.querySelector('[data-evm-gc-card-balance]');
    function showCard(last, balanceText) {
      if (vLast) vLast.textContent = last ? '•••• ' + last : '•••• ••••';
      if (vBal) vBal.textContent = balanceText || 'Wpisz kod, aby zobaczyć saldo';
    }
    function busy(on) {
      button.disabled = on;
      button.textContent = on ? 'Sprawdzam…' : 'Sprawdź saldo';
    }

    var useBtn = form.querySelector('[data-evm-gc-use]');
    var validCode = '';   // kod trzymamy tylko w pamięci strony, do czasu kliknięcia „Użyj w koszyku”

    function useInCart() {
      if (!validCode) return;
      useBtn.disabled = true;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        if (!cart || !cart.item_count) { useBtn.disabled = false; say('err', 'Twój koszyk jest pusty. Dodaj produkty, a potem użyj karty.', '', '', false); return null; }
        return call(Q_ADD_REAL, { id: 'gid://shopify/Cart/' + cart.token, codes: [validCode] }).then(function (r) {
          useBtn.disabled = false;
          var add = r && r.data && r.data.cartGiftCardCodesAdd;
          var cards = (add && add.cart && add.cart.appliedGiftCards) || [];
          if (!cards.length) { say('err', 'Nie udało się dodać karty do koszyka. Wpisz jej kod przy kasie.', '', '', false); return; }
          var c = cards[0];
          var cur = c.balance && c.balance.currencyCode;
          say('ok', 'Karta •••• ' + String(c.lastCharacters || '').toUpperCase() + ' jest w koszyku: ', money(c.amountUsed && c.amountUsed.amount, cur), '. Na karcie zostaje ' + money(c.balance && c.balance.amount, cur) + '. Pieniądze zejdą z karty dopiero po opłaceniu zamówienia.', 'checkout');
        });
      }).catch(function () {
        useBtn.disabled = false;
        say('err', 'Nie udało się dodać karty do koszyka. Wpisz jej kod przy kasie.', '', '', false);
      });
    }
    if (useBtn) useBtn.addEventListener('click', useInCart);

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var code = (input.value || '').replace(/[\s-]+/g, '');
      if (!code) { say('err', 'Wpisz kod z karty podarunkowej.'); input.focus(); return; }
      if (!/^[A-Za-z0-9]{8,20}$/.test(code)) {
        say('err', 'Kod karty ma od 8 do 20 liter i cyfr, bez znaków specjalnych. Sprawdź, czy przepisałeś go bez błędów.');
        input.focus();
        return;
      }
      busy(true);
      status.hidden = true;
      useBtn.hidden = true;
      validCode = '';
      showCard('', '');
      tryCode(code, []).then(function (cards) {
        busy(false);
        if (!cards.length) {
          showCard('', '');
          useBtn.hidden = true;
          validCode = '';
          say('err', 'Nie znaleźliśmy karty o tym kodzie. Sprawdź kod albo napisz do nas: sklep@evamats.pl.');
          return;
        }
        var card = cards[0];
        var last = String(card.lastCharacters || '').toUpperCase();
        showCard(last, money(card.balance && card.balance.amount, card.balance && card.balance.currencyCode));
        validCode = code;
        useBtn.hidden = false;
        say('ok', 'Karta •••• ' + last + ': na karcie zostało ', money(card.balance && card.balance.amount, card.balance && card.balance.currencyCode), '. Możesz użyć jej teraz w koszyku albo wpisać kod przy kasie.', false);
      }).catch(function () {
        busy(false);
        say('err', 'Nie udało się sprawdzić karty. Spróbuj za chwilę albo wpisz kod przy kasie.');
      });
    });
  });
})();
